import {Hint} from '@aboutyou/ui-components';
import React from 'react';
import {SelectedSize} from '../../../features/SizeSelection/hooks/useSelectedSizeState';

export interface AvailabilitySectionViewProps {
  className?: string;
  style?: React.CSSProperties;
  defaultHint: string | undefined;
  selectedSize: SelectedSize | undefined;
}

export const AvailabilitySectionView: React.FC<
  AvailabilitySectionViewProps
> = ({className, style, defaultHint, selectedSize}) => {
  let sizeHint: string | undefined;

  if (selectedSize?.availability?.$case === 'inStock') {
    sizeHint = selectedSize.availability.inStock.lowStockHint;
  }

  const availabilityText = sizeHint ?? defaultHint;

  return availabilityText ? (
    <Hint className={className} style={style} label={availabilityText} />
  ) : null;
};
